import type {ReactNode} from 'react';
import type {ActionMenuItem} from '@Components/action-menu/action-menu.types';

export interface ActionMenuFlyoutProps {
  items: ActionMenuItem[];
  triggerText: string;
  triggerIcon: string;
  infoNote?: ReactNode;
  isDisabled?: boolean;
}

export const FLYOUT_HOVER_INTENT_MS = 300;

export const FLYOUT_TOP_ALIGN_OFFSET = -9;
